<template>
<v-btn
  :href='LINKS.INVITE'
  v-bind=attrs
  target='_blank' >
    <v-icon v-if='icon' small class='mr-1' >{{icon}}</v-icon>
    {{ text }}
</v-btn>
</template>
<script>
import { LINKS } from '@/store/constants'
export default {
  name: 'InviteBtn',
  props: {
    icon: { type: String },
    text: { type: String, default: 'Invite teammates' },
    attrs: { type: Object, default: () => {} }
  },
  data () {
    return {LINKS}
  }
}
</script>



// WEBPACK FOOTER //
// InviteBtn.vue?1859d7f0